import request from './request';

function getPickupStores (data) {

	return request({
		data,
		options: {
			path: '/globalcart/current-cart/pick-up-stores/'
		}
	});

}

export default getPickupStores;
